/**
 * Phase 45 Plan 45-05 — FilterChip.
 *
 * Pure presentational pill: `{label} · {value}` + optional `{count}`.
 *
 * FILTER WIRING DEFERRED TO v7.1 — chips render disabled state only; see
 * CONTEXT D-09 + UI-SPEC §Out-of-Scope. The `disabled` prop dims + removes
 * pointer events; `tooltip` populates the native title attribute (used by
 * the "Custom" period chip's "Coming v7.1" hover hint per RESEARCH Open Q1).
 *
 * Source: UI-SPEC §Surface 1 Filter row spec.
 */
export interface FilterChipProps {
  label: string;
  value: string;
  count?: number | null;
  disabled?: boolean;
  tooltip?: string;
}

export function FilterChip({
  label,
  value,
  count,
  disabled = false,
  tooltip,
}: FilterChipProps) {
  const base =
    'inline-flex items-center gap-1.5 px-2.5 py-1 bg-ms-surface border border-ms-border-subtle rounded-md text-[11.5px]';
  const stateClass = disabled
    ? 'opacity-60 cursor-not-allowed'
    : 'cursor-default';
  return (
    <span className={`${base} ${stateClass}`} title={tooltip}>
      <span className="text-ms-text-muted">{label}</span>
      <span className="text-ms-text-strong font-medium">{value}</span>
      {count !== undefined && count !== null && (
        <span className="text-ms-text-muted tabular-nums">· {count}</span>
      )}
    </span>
  );
}
